export const formatarCEP = (valor: string): string => {
  return !valor ? '-' : valor.replace(/(\d{5})(\d{3})/g, '$1-$2')
}
